
import React from "react"
import '../styles/index.scss';

import Sidebar from '../components/Sidebar';
import NavBar from '../components/NavBar';

import { initAnalytics } from '../utils/analytics';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.handleMenuToggle = this.handleMenuToggle.bind(this);

    this.state = {
      menu_open: false,
    }
  }

  handleMenuToggle(open) {
    this.setState({menu_open: open});
  }

  componentDidMount() {
    initAnalytics();
  }


  render() {
    let {children} = this.props;
  return (
    <div id="outer-container">

        <Sidebar menu_open={this.state.menu_open}
        onMenuToggle={this.handleMenuToggle} />
        

        <NavBar menu_open= {this.state.menu_open}
        onMenuToggle={this.handleMenuToggle}/>

        <main id="page-wrap">
          {/*
            <ScrollingEff />
  */ }
            {children}
      </main>
        
      </div>

  )
  }

};

export default Layout;
